module.exports = __webpack_public_path__ + "assets/img/88.df3e04d3.png";